import React, { useCallback, useMemo, useState } from "react";
import axios from "axios";
import { Link, Redirect, useHistory } from "react-router-dom";
import {
  FaBullhorn,
  FaChalkboardTeacher,
  FaGlobe,
  FaHome,
  FaPlus,
  FaUserGraduate,
  FaUserTie,
} from "react-icons/fa";
import SessionManager from "../Utils/SessionManager";
import MyLoader from "../Spinner/MyLoader";
import myToast from "../Utils/MyToast";
import COLORS from "../resources/colors/COLORS";
import BackButton from "../ChildComponent/BackButton";
import MdlSelectMultipleStudent from "../dialog/MdlSelectMultipleStudent";
import MdlSelectMultipleClass from "../dialog/MdlSelectMultipleClass";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/payroll.css";
import "../css/Admin_css/AddNotice.css";

const API_BASE = () =>
  `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;

const HERO_GRADIENT = `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade7} 55%, ${COLORS.primary_color_shade9} 100%)`;

const PAGE_FONT =
  'Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

const PLACEHOLDER_IMG =
  "https://www.galaxyskills.org/wp-content/uploads/2019/02/dummy-350x350.png";

// Created By Cursor
function classOf(item) {
  return Array.isArray(item?.class) ? item.class[0] || {} : {};
}

// Created By Cursor
export default function AddNotice() {
  const history = useHistory();
  const loggedIn = localStorage.getItem("token") != null;

  const [loading, setLoading] = useState(false);
  const [isOpenSelectStudent, setIsOpenSelectStudent] = useState(false);
  const [isOpenSelectClass, setIsOpenSelectClass] = useState(false);
  const [showSelectedStudent, setShowSelectedStudent] = useState(false);
  const [showSelectedClass, setShowSelectedClass] = useState(false);
  const [mSelectedStudent, setMSelectedStudent] = useState([]);
  const [mSelectedClass, setMSelectedClass] = useState([]);

  const [isCheckedChkGlobal, setIsCheckedChkGlobal] = useState(false);
  const [isCheckedChkStudent, setIsCheckedChkStudent] = useState(false);
  const [isCheckedChkClass, setIsCheckedChkClass] = useState(false);
  const [isCheckedChkStaff, setIsCheckedChkStaff] = useState(false);

  const [flagAllStudent, setFlagAllStudent] = useState(true);
  const [flagSelectStudent, setFlagSelectStudent] = useState(false);
  const [flagAllClass, setFlagAllClass] = useState(true);
  const [flagSelectClass, setFlagSelectClass] = useState(false);

  const [orderedBy, setOrderedBy] = useState("Principal");
  const [notice, setNotice] = useState("");
  const [noticeUrl, setNoticeUrl] = useState("");
  const [attachFile, setAttachFile] = useState(null);
  const [attachPreview, setAttachPreview] = useState("");

  const handleAttachChange = (e) => {
    const file = e.target.files?.[0] || null;
    if (!file) {
      setAttachFile(null);
      setAttachPreview("");
      return;
    }
    const allowed = [
      "application/pdf",
      "image/jpeg",
      "image/png",
      "image/gif",
      "image/webp",
    ];
    const nameOk = /\.(pdf|jpe?g|png|gif|webp)$/i.test(file.name || "");
    if (!allowed.includes(file.type) && !nameOk) {
      myToast.notify_warning("Only PDF or image files are allowed.");
      e.target.value = "";
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      myToast.notify_warning("File too large. Max 10MB.");
      e.target.value = "";
      return;
    }
    setAttachFile(file);
    if (file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onloadend = () => setAttachPreview(String(reader.result || ""));
      reader.readAsDataURL(file);
    } else {
      setAttachPreview("");
    }
  };

  const clearAttachment = () => {
    setAttachFile(null);
    setAttachPreview("");
    const input = document.getElementById("input_file");
    if (input) input.value = "";
  };

  const goNoticeBoard = useCallback(() => {
    history.push("/AdminMain/NoticeBoard/1");
  }, [history]);

  const onChangeChkGlobal = (e) => {
    const checked = e.target.checked;
    if (checked) {
      setIsCheckedChkGlobal(true);
      setIsCheckedChkStudent(false);
      setIsCheckedChkClass(false);
      setIsCheckedChkStaff(false);
    } else {
      setIsCheckedChkGlobal(false);
    }
  };

  const onChangeChkStudent = (e) => {
    const checked = e.target.checked;
    if (checked) {
      setIsCheckedChkGlobal(false);
      setIsCheckedChkStudent(true);
      setFlagAllStudent(true);
      setFlagSelectStudent(false);
    } else {
      setIsCheckedChkStudent(false);
    }
  };

  const onChangeChkClass = (e) => {
    const checked = e.target.checked;
    if (checked) {
      setIsCheckedChkGlobal(false);
      setIsCheckedChkClass(true);
      setFlagAllClass(true);
      setFlagSelectClass(false);
    } else {
      setIsCheckedChkClass(false);
    }
  };

  const onChangeChkStaff = (e) => {
    const checked = e.target.checked;
    if (checked) {
      setIsCheckedChkGlobal(false);
      setIsCheckedChkStaff(true);
    } else {
      setIsCheckedChkStaff(false);
    }
  };

  const toAllStudent = () => {
    setFlagAllStudent(true);
    setFlagSelectStudent(false);
    setFlagAllClass(false);
    setFlagSelectClass(false);
    setIsCheckedChkClass(false);
  };

  const selectStudent = () => {
    setFlagAllStudent(false);
    setFlagSelectStudent(true);
    setFlagAllClass(false);
    setIsOpenSelectStudent(true);
  };

  const toAllClass = () => {
    setFlagAllClass(true);
    setFlagSelectClass(false);
    setFlagAllStudent(false);
    setFlagSelectStudent(false);
    setIsCheckedChkStudent(false);
  };

  const selectClass = () => {
    setFlagAllClass(false);
    setFlagSelectClass(true);
    setFlagAllStudent(false);
    setIsOpenSelectClass(true);
  };

  const handleSelectedStudent = (selected) => {
    const list = Array.isArray(selected) ? selected : [];
    setIsOpenSelectStudent(false);
    setShowSelectedStudent(true);
    setMSelectedStudent(list);
  };

  const handleSelectedClass = () => {
    let list = [];
    try {
      list = JSON.parse(localStorage.getItem("SelectedMultipleClass")) || [];
    } catch (err) {
      list = [];
    }
    if (!Array.isArray(list)) list = [];
    setIsOpenSelectClass(false);
    setShowSelectedClass(true);
    setMSelectedClass(list);
  };

  const prepareRecipient = useCallback(() => {
    const list = [];
    if (isCheckedChkGlobal) {
      list.push("GLOBAL");
      return list;
    }
    if (isCheckedChkStudent) {
      if (flagAllStudent) {
        list.push("ALL_STUDENT");
      } else if (flagSelectStudent) {
        mSelectedStudent.forEach((row) => {
          if (row?.student_enrollment_no) {
            list.push(row.student_enrollment_no);
          }
        });
      }
    }
    if (isCheckedChkClass) {
      if (flagAllClass) {
        list.push("ALL_CLASS");
      } else if (flagSelectClass) {
        mSelectedClass.forEach((row) => {
          const classId = row?.class_id;
          if (!classId) return;
          const sectionId =
            row?.section_id != null && String(row.section_id) !== ""
              ? row.section_id
              : "No";
          list.push(`${classId}#${sectionId}`);
        });
      }
    }
    if (isCheckedChkStaff) {
      list.push("ALL_STAFF");
    }
    return list;
  }, [
    isCheckedChkGlobal,
    isCheckedChkStudent,
    isCheckedChkClass,
    isCheckedChkStaff,
    flagAllStudent,
    flagSelectStudent,
    flagAllClass,
    flagSelectClass,
    mSelectedStudent,
    mSelectedClass,
  ]);

  const isValidInput = () => {
    if (!String(notice || "").trim()) {
      myToast.notify_warning("Enter notice.");
      return false;
    }
    if (!String(orderedBy || "").trim()) {
      myToast.notify_warning("Enter ordered by.");
      return false;
    }
    if (
      !isCheckedChkGlobal &&
      !isCheckedChkStudent &&
      !isCheckedChkClass &&
      !isCheckedChkStaff
    ) {
      myToast.notify_warning("Please select a recipient.");
      return false;
    }
    if (
      isCheckedChkStudent &&
      flagSelectStudent &&
      mSelectedStudent.length === 0
    ) {
      myToast.notify_warning("Please select at least one student.");
      return false;
    }
    if (isCheckedChkClass && flagSelectClass && mSelectedClass.length === 0) {
      myToast.notify_warning("Please select at least one class.");
      return false;
    }
    return true;
  };

  const submitNotice = async () => {
    if (!isValidInput()) return;

    const recipients = prepareRecipient();
    if (!recipients.length) {
      myToast.notify_warning("Please select a recipient.");
      return;
    }

    const rawUrl = String(noticeUrl || "").trim();
    let urlTrim = rawUrl;
    if (urlTrim && !/^https?:\/\//i.test(urlTrim)) {
      urlTrim = `https://${urlTrim}`;
    }

    const schoolCode = SessionManager.getSchoolCode();
    const staff = SessionManager.getStaffDetails() || {};
    const staffId = staff.staff_id;
    const sessions = SessionManager.getCurrentSession();
    const sessionId = Array.isArray(sessions) ? sessions[0]?.session_id : "";
    if (!schoolCode || !staffId || !sessionId) {
      myToast.notify_warning("Missing staff, school, or session details.");
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("notice", notice.trim());
      formData.append("recipient", JSON.stringify(recipients));
      formData.append("staff_id", staffId);
      formData.append("ordered_by", orderedBy.trim());
      formData.append("session_id", sessionId);
      formData.append("school_code", schoolCode);
      formData.append("notice_url", urlTrim);
      if (attachFile) formData.append("attachment", attachFile);

      // Let browser set multipart boundary — do not force Content-Type
      const response = await axios
        .post(`${API_BASE()}addNotice.php`, formData)
        .then((res) => res.data);

      if (response?.api_status === "OK") {
        myToast.notify_success(
          response?.api_remark || "Notice submitted successfully."
        );
        goNoticeBoard();
      } else {
        myToast.notify_warning(response?.api_remark || "Failed to add notice.");
      }
    } catch (error) {
      console.error(error);
      myToast.notify_warning("Failed to add notice.");
    } finally {
      setLoading(false);
    }
  };

  const recipientSummary = useMemo(() => {
    const parts = [];
    if (isCheckedChkGlobal) parts.push("Global");
    if (isCheckedChkStudent) {
      parts.push(
        flagAllStudent
          ? "All students"
          : `${mSelectedStudent.length} student${
              mSelectedStudent.length === 1 ? "" : "s"
            }`
      );
    }
    if (isCheckedChkClass) {
      parts.push(
        flagAllClass
          ? "All classes"
          : `${mSelectedClass.length} class${
              mSelectedClass.length === 1 ? "" : "es"
            }`
      );
    }
    if (isCheckedChkStaff) parts.push("All staff");
    return parts.length ? parts.join(" · ") : "No recipient selected";
  }, [
    isCheckedChkGlobal,
    isCheckedChkStudent,
    isCheckedChkClass,
    isCheckedChkStaff,
    flagAllStudent,
    flagAllClass,
    mSelectedStudent.length,
    mSelectedClass.length,
  ]);

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  return (
    <div
      className="content payroll-page sm-page an-page"
      style={{ fontFamily: PAGE_FONT }}
    >
      <div
        className="content-header d-flex justify-content-between align-items-center"
        style={{ background: COLORS.primary_color_shade5 }}
      >
        <div className="leftside-content-header d-flex align-items-center gap-2">
          <button
            type="button"
            className="qb-home-btn"
            aria-label="Home"
            onClick={() => history.push("/AdminMain")}
          >
            <FaHome />
          </button>
          <ul className="breadcrumbs mb-0">
            <li>
              <button
                type="button"
                className="an-crumb-link"
                onClick={goNoticeBoard}
              >
                Notice Board
              </button>
            </li>
            <li>
              <span style={{ color: COLORS.white }}>Add Notice</span>
            </li>
          </ul>
        </div>
        <div className="rightside-content-header">
          <BackButton />
        </div>
      </div>

      <div className="bg_page_white_rounded box_shadow animated fadeInUp sm-shell an-shell">
        <header className="sm-hero" style={{ "--sm-hero-bg": HERO_GRADIENT }}>
          <div className="sm-hero__brand">
            <div className="sm-hero__icon" aria-hidden>
              <FaPlus />
            </div>
            <div className="min-w-0">
              <h1 className="sm-hero__title">Add Notice</h1>
              <p className="sm-hero__sub">{recipientSummary}</p>
            </div>
          </div>
          <div className="sm-hero__tools">
            <button
              type="button"
              className="an-hero-btn"
              onClick={goNoticeBoard}
              disabled={loading}
            >
              <FaBullhorn aria-hidden /> Board
            </button>
            <button
              type="button"
              className="an-hero-btn an-hero-btn--solid"
              onClick={submitNotice}
              disabled={loading}
            >
              <FaPlus aria-hidden />
              {loading ? "Saving…" : "Publish"}
            </button>
          </div>
        </header>

        <div className="an-body">
          {loading ? (
            <div className="an-loading">
              <MyLoader />
            </div>
          ) : null}

          <div className="an-summary">
            <div className="an-summary__icon" aria-hidden>
              <FaBullhorn />
            </div>
            <div className="an-summary__text">
              <strong>Audience</strong>
              <span>{recipientSummary}</span>
            </div>
          </div>

          <section className="an-section an-section--details">
            <h2 className="an-section__title">
              <span className="an-section__step" aria-hidden>
                1
              </span>
              <span className="an-section__title-icon" aria-hidden>
                <FaBullhorn />
              </span>
              Notice details
            </h2>
            <div className="an-section__body">
              <div className="an-grid an-grid--2">
                <div className="an-field">
                  <label className="an-field__label" htmlFor="input_ordered_by">
                    Ordered by
                  </label>
                  <input
                    type="text"
                    id="input_ordered_by"
                    className="an-input"
                    value={orderedBy}
                    onChange={(e) => setOrderedBy(e.target.value)}
                    disabled={loading}
                  />
                </div>
                <div className="an-field">
                  <label className="an-field__label" htmlFor="input_notice_url">
                    Link / URL
                  </label>
                  <input
                    type="url"
                    id="input_notice_url"
                    className="an-input"
                    value={noticeUrl}
                    onChange={(e) => setNoticeUrl(e.target.value)}
                    disabled={loading}
                    placeholder="https://example.com/notice"
                  />
                </div>
              </div>

              <div className="an-field an-field--wide an-field--attach">
                <label className="an-field__label" htmlFor="input_file">
                  Document (PDF or image)
                </label>
                <div className="an-attach">
                  <label className="an-file" htmlFor="input_file">
                    <span className="an-file__btn">Choose file</span>
                    <span className="an-file__hint">
                      {attachFile
                        ? attachFile.name
                        : "PDF, JPG, PNG, GIF, WEBP · max 10MB"}
                    </span>
                    <input
                      type="file"
                      id="input_file"
                      className="an-file__input"
                      accept=".pdf,image/*,.jpg,.jpeg,.png,.gif,.webp"
                      onChange={handleAttachChange}
                      disabled={loading}
                    />
                  </label>
                  {attachFile ? (
                    <button
                      type="button"
                      className="an-attach__clear"
                      onClick={clearAttachment}
                      disabled={loading}
                    >
                      Remove
                    </button>
                  ) : null}
                </div>
                {attachPreview ? (
                  <img
                    className="an-attach__preview"
                    src={attachPreview}
                    alt="Attachment preview"
                  />
                ) : null}
                {attachFile && !attachPreview ? (
                  <div className="an-attach__pdf">
                    <i className="fa fa-file-pdf-o" aria-hidden="true" />
                    <span>{attachFile.name}</span>
                  </div>
                ) : null}
              </div>

              <div className="an-field an-field--wide an-field--notice">
                <div className="an-field__head">
                  <label className="an-field__label" htmlFor="input_notice">
                    Notice *
                  </label>
                  <span className="an-field__count">
                    {String(notice || "").trim().length} chars
                  </span>
                </div>
                <textarea
                  id="input_notice"
                  className="an-textarea"
                  rows={6}
                  value={notice}
                  onChange={(e) => setNotice(e.target.value)}
                  disabled={loading}
                  placeholder="Write a clear notice for students, classes, or staff…"
                />
              </div>
            </div>
          </section>

          <section className="an-section an-section--recipients">
            <h2 className="an-section__title">
              <span className="an-section__step" aria-hidden>
                2
              </span>
              <span className="an-section__title-icon" aria-hidden>
                <FaGlobe />
              </span>
              Recipients
            </h2>
            <div className="an-section__body an-recipients">
              <div
                className={`an-recip an-recip--global${
                  isCheckedChkGlobal ? " is-on" : ""
                }`}
              >
                <label className="an-check">
                  <input
                    type="checkbox"
                    id="issue_notice_gs"
                    checked={isCheckedChkGlobal}
                    onChange={onChangeChkGlobal}
                    disabled={loading}
                  />
                  <span className="an-check__icon" aria-hidden>
                    <FaGlobe />
                  </span>
                  <span className="an-check__text">
                    <strong>Global school</strong>
                    <small>All students and all staff</small>
                  </span>
                </label>
                {isCheckedChkGlobal ? (
                  <div className="an-panel">
                    <p className="an-panel__hint">
                      Notice will be issued to everyone in the school.
                    </p>
                  </div>
                ) : null}
              </div>

              <div
                className={`an-recip an-recip--student${
                  isCheckedChkStudent && !isCheckedChkGlobal ? " is-on" : ""
                }${isCheckedChkGlobal ? " is-disabled" : ""}`}
              >
                <label className="an-check">
                  <input
                    type="checkbox"
                    id="issue_notice_s"
                    checked={isCheckedChkStudent}
                    onChange={onChangeChkStudent}
                    disabled={loading || isCheckedChkGlobal}
                  />
                  <span className="an-check__icon" aria-hidden>
                    <FaUserGraduate />
                  </span>
                  <span className="an-check__text">
                    <strong>Students</strong>
                    <small>All students or selected students</small>
                  </span>
                </label>
                {isCheckedChkStudent && !isCheckedChkGlobal ? (
                  <div className="an-panel">
                    <div className="an-option-row">
                      <button
                        type="button"
                        className={`an-option-btn${
                          flagAllStudent ? " is-active" : ""
                        }`}
                        onClick={toAllStudent}
                        disabled={loading}
                      >
                        To all students
                      </button>
                      <button
                        type="button"
                        className={`an-option-btn${
                          flagSelectStudent ? " is-active" : ""
                        }`}
                        onClick={selectStudent}
                        disabled={loading}
                      >
                        Select students
                      </button>
                    </div>
                    {flagAllStudent ? (
                      <p className="an-panel__hint">All students selected.</p>
                    ) : null}
                    {showSelectedStudent && flagSelectStudent ? (
                      <div className="an-pick-list">
                        {mSelectedStudent.length === 0 ? (
                          <p className="an-panel__hint">No students selected.</p>
                        ) : (
                          mSelectedStudent.map((item, index) => {
                            const cls = classOf(item);
                            return (
                              <div
                                className="an-pick-item"
                                key={item.student_enrollment_no || index}
                              >
                                <img
                                  className="an-pick-item__avatar"
                                  src={item.student_img_path || PLACEHOLDER_IMG}
                                  alt=""
                                />
                                <div className="an-pick-item__main">
                                  <strong>{item.stu_name || "—"}</strong>
                                  <span>
                                    {item.student_enrollment_no || "—"}
                                    {cls.class_name
                                      ? ` · ${cls.class_name}${
                                          cls.section_name
                                            ? `:${cls.section_name}`
                                            : ""
                                        }`
                                      : ""}
                                    {cls.student_roll_no
                                      ? ` · Roll ${cls.student_roll_no}`
                                      : ""}
                                  </span>
                                </div>
                              </div>
                            );
                          })
                        )}
                      </div>
                    ) : null}
                  </div>
                ) : null}
              </div>

              <div
                className={`an-recip an-recip--class${
                  isCheckedChkClass && !isCheckedChkGlobal ? " is-on" : ""
                }${isCheckedChkGlobal ? " is-disabled" : ""}`}
              >
                <label className="an-check">
                  <input
                    type="checkbox"
                    id="issue_notice_c"
                    checked={isCheckedChkClass}
                    onChange={onChangeChkClass}
                    disabled={loading || isCheckedChkGlobal}
                  />
                  <span className="an-check__icon" aria-hidden>
                    <FaChalkboardTeacher />
                  </span>
                  <span className="an-check__text">
                    <strong>Classes</strong>
                    <small>All classes or selected classes</small>
                  </span>
                </label>
                {isCheckedChkClass && !isCheckedChkGlobal ? (
                  <div className="an-panel">
                    <div className="an-option-row">
                      <button
                        type="button"
                        className={`an-option-btn${
                          flagAllClass ? " is-active" : ""
                        }`}
                        onClick={toAllClass}
                        disabled={loading}
                      >
                        To all classes
                      </button>
                      <button
                        type="button"
                        className={`an-option-btn${
                          flagSelectClass ? " is-active" : ""
                        }`}
                        onClick={selectClass}
                        disabled={loading}
                      >
                        Select classes
                      </button>
                    </div>
                    {flagAllClass ? (
                      <p className="an-panel__hint">All classes selected.</p>
                    ) : null}
                    {showSelectedClass && flagSelectClass ? (
                      <div className="an-pick-list">
                        {mSelectedClass.length === 0 ? (
                          <p className="an-panel__hint">No classes selected.</p>
                        ) : (
                          mSelectedClass.map((item, index) => (
                            <div
                              className="an-pick-item"
                              key={`${item.class_id}-${item.section_id}-${index}`}
                            >
                              <div className="an-pick-item__badge" aria-hidden>
                                <FaChalkboardTeacher />
                              </div>
                              <div className="an-pick-item__main">
                                <strong>
                                  {item.section === "No" ||
                                  item.section_id === "No"
                                    ? `Class: ${item.class_name || "—"}`
                                    : `${item.class_name || "—"}: ${
                                        item.section_name || "—"
                                      }`}
                                </strong>
                                <span>
                                  {[item.board_name, item.medium_name]
                                    .filter(Boolean)
                                    .join(" · ") || "—"}
                                  {item.student != null
                                    ? ` · ${item.student} students`
                                    : ""}
                                </span>
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    ) : null}
                  </div>
                ) : null}
              </div>

              <div
                className={`an-recip an-recip--staff${
                  isCheckedChkStaff && !isCheckedChkGlobal ? " is-on" : ""
                }${isCheckedChkGlobal ? " is-disabled" : ""}`}
              >
                <label className="an-check">
                  <input
                    type="checkbox"
                    id="issue_notice_st"
                    checked={isCheckedChkStaff}
                    onChange={onChangeChkStaff}
                    disabled={loading || isCheckedChkGlobal}
                  />
                  <span className="an-check__icon" aria-hidden>
                    <FaUserTie />
                  </span>
                  <span className="an-check__text">
                    <strong>Staff</strong>
                    <small>All staff members</small>
                  </span>
                </label>
                {isCheckedChkStaff && !isCheckedChkGlobal ? (
                  <div className="an-panel">
                    <p className="an-panel__hint">All staff selected.</p>
                  </div>
                ) : null}
              </div>
            </div>
          </section>

          <div className="an-actions">
            <Link
              to="/AdminMain/NoticeBoard/1"
              className="an-btn an-btn--secondary"
            >
              Cancel
            </Link>
            <button
              type="button"
              className="an-btn an-btn--primary"
              onClick={submitNotice}
              disabled={loading}
            >
              <FaPlus aria-hidden />
              {loading ? "Saving…" : "Add Notice"}
            </button>
          </div>
        </div>
      </div>

      {isOpenSelectStudent ? (
        <MdlSelectMultipleStudent
          actionClose={() => setIsOpenSelectStudent(false)}
          actionHandleSelected={handleSelectedStudent}
        />
      ) : null}

      {isOpenSelectClass ? (
        <MdlSelectMultipleClass
          action={() => setIsOpenSelectClass(false)}
          action2={handleSelectedClass}
        />
      ) : null}
    </div>
  );
}
